import { render, staticRenderFns } from "./WaybillForm.vue?vue&type=template&id=702423ea&scoped=true"
import script from "./WaybillForm.vue?vue&type=script&lang=js"
export * from "./WaybillForm.vue?vue&type=script&lang=js"
import style0 from "./WaybillForm.vue?vue&type=style&index=0&id=702423ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702423ea",
  null
  
)

export default component.exports